const possibleTypes = {
  Page: ['Page', 'ExternalPage', 'BottlebooksPage'],
};

export default possibleTypes;
